module.exports = __webpack_public_path__ + "static/media/sortUp-16.0dcea084.svg";